// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CartHeader: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 55"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M62.6 12.7c-.5-.6-1.2-1-1.9-1L13 8.7l-.6-3.2v-.2c-.5-1.1-1.4-1.9-2.6-1.9H2.3c-.7 0-1.3.7-1.3 1.4s.6 1.4 1.4 1.4h7.3l7.4 37.6c-.4.7-.6 1.4-.6 2.2 0 2.5 2.1 4.6 4.6 4.6s4.6-2.1 4.6-4.6c0-.7-.1-1.3-.4-1.9h26.5c-.3.6-.4 1.2-.4 1.9 0 2.5 2.1 4.6 4.6 4.6s4.6-2.1 4.6-4.6c0-2.4-1.9-4.4-4.3-4.6H19.4l-1.2-5.9h40.2c1.4 0 2.5-1 2.6-2.3l2-18.6c.1-.7 0-1.3-.4-1.9zM22.9 46c0 1-.8 1.9-1.9 1.9s-1.8-.9-1.8-1.9.8-1.9 1.9-1.9 1.8.8 1.8 1.9zM56 47.8c-1 0-1.9-.8-1.9-1.9S54.9 44 56 44s1.9.8 1.9 1.9-.9 1.9-1.9 1.9zm2.3-15.1H17.7l-4.2-21.2 46.7 2.9-1.9 18.3z"/></svg>;
};

export default React.memo(CartHeader);
